import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unlink: {
		id: 'roadmap.timeline-table-kit.common.dependency.unlink-button.unlink',
		defaultMessage: 'Unlink issue',
		description: 'Icon and tooltip label. Appears on the link delete button.',
	},
});
